import React from "react";
import { Avatar, Card, Divider, Popover } from "antd";
import { CATEGORY_CONFIG } from "variables/constants";
import { Briefcase, Trophy } from "lucide-react";

const mockUsers = [
  {
    id: 1,
    name: "Alice Johnson",
    country: "🇵🇭 Philippines",
    category: "Culture Hero",
    role: "DevOps Engineer",
    awardMonth: "September 2025",
    achievement:
      "Consistently demonstrated Hyvid values in client interactions and team collaboration",
  },
  {
    id: 2,
    name: "Bob Martinez",
    country: "🇵🇭 Philippines",
    category: "Values in Action",
    role: "Marketing Manager",
    awardMonth: "October 2025",
    achievement:
      "Delivers exceptional results with clear, measurable impact",
  },
  {
    id: 3,
    name: "Catherine Wu",
    country: "🇦🇺 Australia",
    category: "Peak Performer",
    role: "Software Engineer",
    awardMonth: "November 2025",
    achievement:
      "Exceeds targets regularly and improves team efficiency through mentoring",
  },
  {
    id: 4,
    name: "Daniel Kim",
    country: "🇦🇺 Australia",
    category: "Innovation Trailblazer",
    role: "Product Designer",
    awardMonth: "October 2025",
    achievement:
      "Introduced new design frameworks that improved user engagement by 25%",
  },
  {
    id: 5,
    name: "Evelyn Park",
    country: "🇦🇺 Australia",
    category: "CEO Award",
    role: "Project Manager",
    awardMonth: "December 2025",
    achievement:
      "Leads cross-functional initiatives that generate company-wide value",
  },
  {
    id: 6,
    name: "Franklin Ng",
    country: "🇦🇺 Australia",
    category: "AI Adoption Champion",
    role: "Data Scientist",
    awardMonth: "December 2025",
    achievement:
      "Led the team in implementing AI-powered automation tools, increasing productivity by 40%",
  },
];


const AwardeeDetails = ({ name, role, category, country, achievement }) => {
  const normalizedKey = category.toLowerCase().replace(/\s+/g, "-");
  const { icon: Icon, colorClass } = CATEGORY_CONFIG[normalizedKey] || {};
  const initials = name
      ?.split(" ")
      .map((n) => n[0])
      .join("");

  return (
    <Card className={`flex rounded-xl card-theme ${colorClass} w-full hover:shadow-md transition-all`}>
        <div className="flex items-start justify-between ">
          <div className="relative inline-block">
            <Avatar
              size={64}
              className={`!rounded-full border-4 border-white shadow-md icon-style ${colorClass} flex items-center justify-center`}
            >
              {initials}
            </Avatar>
            <Popover
              content={category}
              trigger="hover"
              placement="top"
              overlayClassName="reward-popover"
            >
              <div
                className={`absolute -right-1 -bottom-1 w-8 h-8 !rounded-full icon-style ${colorClass} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
              >
                {Icon && <Icon className="w-4 h-4 text-white" />}
              </div>
            </Popover>
          </div>
          <span className={`status-indicator ${colorClass} text-xs`}>{category}</span>
        </div>

          <div className="flex flex-col mt-3 space-y-3">
            <div>
              <h4 className="flex gap-2 font-semibold text-base text-gray-800">
                {name}
              </h4>
              <p className="text-xs mb-2">{role}</p>
              <p className="text-xs text-slate-700">{country}</p>
            </div>
            <span className="inline-flex gap-1 items-center text-[10px] text-slate-700 flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-200 w-fit">
              <Briefcase className="w-3 h-3"/> 
              TechCorp Solutions
            </span>
          </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />
        <p className="text-slate-700 text-xs">
          {achievement}
        </p>
    </Card>
  );
};

const AwardeeCard = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3"> 
      {mockUsers.map((user) => (
        <AwardeeDetails
          key={user.id}
          category={user.category}
          name={user.name}
          role={user.role}
          awardMonth={user.awardMonth}
          achievement={user.achievement}
          country={user.country}
        />
      ))}
    </div>
    
  );
};

export default AwardeeCard;
